import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TextEditorCustom from '../../../components/text-editor/TextEditorCustom';
import ContainerButton from '../../../components/button/ContainerButton';
import { ContentPDPAApi } from '../../../api/content-pdpa/content-pdpa.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { alertError, alertSuccess } from '../../../components/alert/swal';

export default function ManagePDPA() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [disabled, setDisabled] = useState(true)
    const [form, setForm] = useState<any>()

    const getDetail = async () => {
        await ContentPDPAApi.findOne()
            .then((res) => {
                if (res.status < 300) {
                    setForm(res.data.data)
                }
            })
            .catch((err) => {
                console.log(err);
                // alertError("เพิ่มข้อสอบ", "เพิ่มข้อสอบ ไม่สำเร็จ");
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }

    useEffect(() => {
        getDetail()
    }, [])
    const handleSubmit = async () => {
        const body = form
        dispatch(setLoading());

        await ContentPDPAApi.create(body)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("MANAGE_PDPA_UPDATE_COMPLETED"));
                    setDisabled(true)
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("MANAGE_PDPA_UPDATE_FAILED"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("MANAGE_PDPA")}
                // hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("ตั้งค่า"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("หมวดหมู่แกลเลอรี"),
                //                 pathName: routeName.cms_website.GalleryTypeManagement
                //             },
                //         ]}
                //     />
                // }
                buttonContent={
                    // <ContainerButton
                    //     justifyContent='flex-end'
                    //     buttonData={[
                    //         {
                    //             buttonProps: {
                    //                 onClick: handleDownloadReport
                    //             },
                    //             key: "DOWNLOAD_CSV",
                    //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
                    //             seq: 1,
                    //             type: "DOWNLOAD_CSV"
                    //         }
                    //     ]}
                    // />
                    <></>
                }
                content={
                    <div className='w-full'>
                        <Typography sx={{ fontWeight: '600', marginBottom: '20px' }}>{t('MANAGE_PDPA_NOTICE_CONTENT')}</Typography>
                        <section className='my-4 w-full overflow-auto'>
                            <TextEditorCustom
                                disabled={disabled}
                                sx={{ height: "100%", minHeight: "500px" }}
                                height={'500px'}
                                onChange={(text) => { setForm({ content_pdpa: text }) }}
                                textString={form?.content_pdpa || ''} />
                        </section>
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { setDisabled(true) },
                                    },
                                    key: "CANCEL",
                                    label: t("MANAGE_PDPA_CANCEL"),
                                    type: "CANCEL",
                                    hidden: disabled
                                },
                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            setDisabled(false)
                                        }
                                    },
                                    hidden: !disabled,
                                    key: "EDIT",
                                    label: t("MANAGE_PDPA_EDIT"),
                                    type: 'EDIT'
                                },
                                {
                                    seq: 2,
                                    hidden: disabled,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    key: "SEND",
                                    label: t("MANAGE_PDPA_CONFIRM"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>
                }
            />

        </div>
    )
}
